import classes from "./MealsSummary.module.css";

const MealsSumarry = () => {
  return (
    <section className={classes.summary}>
      <h2>Delicious Food, Delivered To You</h2>
      <p>
        Choose your favorite meal from our broad selection of cuisines!
      </p>
      <p>
        All our meals are cooked fresh with high-quality ingredients by 2 Michellin starred chefs!
      </p>
    </section>
  );
};
export default MealsSumarry;
